export default __webpack_public_path__ + "static/media/Vector.67fa7d56.svg";